module.exports = __webpack_public_path__ + "static/media/SignupStep1.9d42d0c5.png";